import React, { useState ,useEffect} from "react";
import axios from "axios";

import {
  Card,
  Button,
  Modal,
  Form,
} from 'react-bootstrap';
import { Icon } from '@iconify/react';
import DataTable from "react-data-table-component";
import { Link } from 'react-router-dom';
import { getFeedbacks,destroyFeedback } from "../../api/feedbackSupportService";
import { sendMail } from "../../api/revenueService";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { toast } from "react-toastify";
import { reportSchema } from "../../validations/authSchema";

export default function Feedback() {
  const [searchText, setSearchText] = useState('');
  const [show, setShow] = useState(false);
  const [feedbacks, setFeedbacks] =useState([]);
  const [feedbackToDelete, setFeedbackToDelete] = useState(null);
  const [loading, setLoading] = useState(false);  // Add this state for loading

  const handleClose = () => setShow(false);
  const [sent, setSent] = useState(false);
  const senttoggle = () => setSent(!sent);
  const [email, setEmail] = useState('');
  const [subject, setSubject] = useState('');
  const [content, setContent] = useState(''); 
  const [feedbackId, setFeedbackId] = useState(null);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(reportSchema),
  });

  const getStatusStyle = (status) => {
    switch (status) {
      case 'Open':
        return {
          backgroundColor: 'rgba(40, 199, 111, 0.12)',
          color: '#28c76f',
          padding: '5px 10px',
          borderRadius: '5px',
          display: 'inline-block'
        };
        case 'In progress':
          return {
            backgroundColor: 'rgba(234, 69, 89, 0.12)',
            color: '#EA4559',
            padding: '5px 10px',
            borderRadius: '5px',
            display: 'inline-block'
          };
        case 'Closed':
          return {
            backgroundColor: 'rgba(146, 0, 0, 0.12)',
            color: '#920000',
            padding: '5px 10px',
            borderRadius: '5px',
            display: 'inline-block'
          };
      default:
        return {};
    }
  };


  useEffect(()=>{
    fetchFeedbacks()
  },[])

const fetchFeedbacks = (page, size) => {
  setLoading(true);  
  getFeedbacks()
      .then((response) => {
        if (response.data) {
            setFeedbacks(response.data);
        //   setTotalUsers(response.data.pagination.totalUsers); 
        }
      })
      .catch((error) => console.error("Error fetching users", error))
      .finally(() => setLoading(false));
  };

const handleDeleteFeedback = () => {
    if (!feedbackToDelete) return; 

    destroyFeedback(feedbackToDelete)
      .then((response) => {
        if (response.data) {
        
          setFeedbacks((prevFeedbacks) => prevFeedbacks.filter((feedback) => feedback._id !== feedbackToDelete));
          setShow(false); 
          setFeedbackToDelete(null); 
        }
      })
      .catch((error) => {
        console.error("Error deleting tale", error);
        alert("Failed to delete tale. Please try again.");
      });
  };


  const handleSendMessage = (data) => {
    try {
    data.email = email;
    data.feedbackId = feedbackId;
    sendMail(data)
      .then((response) => {
        if (response.code === 200) {
          toast.success(response.message);
          setSent(false); 
          setEmail('');
          setSubject('');
          setContent('');
          setFeedbackId(null); 
        }else{
          toast.error(response.message);
        }
      })
      .catch((error) => {
        console.error("Error sending mail", error);
        toast.error("Failed to send email. Please try again.");
      });
    } catch (error) {
      toast.error(error.message);
    }
  };
  

  const handleShowDeleteModal = (id) => {
    setFeedbackToDelete(id); 
    setShow(true); 
  };

  const handleOpenSendMessage = (row) => {
    setEmail(row.userId.email); 
    setFeedbackId(row._id); 
    setSent(true); 
  };


  const columns = [
    {
      name: 'ID',
      width: '130px',
      selector: row => row._id,
      sortable: true,
      cell: (row) => row._id     
    },
    {
      name: 'User',
      width: '180px',
      selector: row => row.userId.fullName,
      sortable: true,
      cell: (row) => row.userId.fullName
    },
    {
      name: 'Feedback Type',
      width: '170px',
      selector: row => row.feedBackType,
      sortable: true,
      cell: (row) => row.feedBackType
    },
    {
      name: 'Date Submitted',
      width: '180px',
      selector: row => new Date(row.createdAt).toLocaleDateString(),
      sortable: true,
      cell: (row) => new Date(row.createdAt).toLocaleDateString()
    },
    {
      name: 'Status',
      width: '150px',
      selector: row => row.Status,
      sortable: true,
      cell: (row) => <span  style={getStatusStyle(row.status)}>{row.status}</span>
    },
    {
      name: 'Actions',
      width: '150px',
      cell: row => (
        <>
          <Link className="btnview" to={`/admin/feedback-detail/${row._id}`}>
            <Icon icon="tabler:eye"></Icon>
          </Link>
          <Link className="btnedit" onClick={() => handleOpenSendMessage(row)}>
            <Icon icon="lucide:message-square"></Icon>
          </Link>
          <Link className="btndelete" onClick={() => handleShowDeleteModal(row._id)}>
            <Icon icon="tabler:trash"></Icon>
          </Link>
        </>
      ),
    },
  ];
 

  const filteredData = feedbacks.filter(
    item => {
      const searchStr= searchText.toLocaleLowerCase();
      return (
        item.userId.fullName.toLowerCase().includes(searchStr) ||
        item.feedBackType.toLowerCase().includes(searchStr) ||
        item.status.toLowerCase().includes(searchStr) ||
        item._id.toLowerCase().includes(searchStr)
      )
    }
       
);

  return (
    <React.Fragment>
      <Card>
        <Card.Header className="py-4">
          <h5>Feedback</h5>
        </Card.Header>
        <Card.Body>
          <div className="text-end mb-3">
            <input
              type="text"
              placeholder="Search..."
              className="searchfield"
              value={searchText}
              onChange={e => setSearchText(e.target.value)}
            />
          </div>
          <DataTable
            columns={columns}
            data={filteredData}
            pagination
            responsive
            progressPending={loading}
            className="custom-table"
          />
        </Card.Body>
      </Card>
      <Modal className="modal_Delete" show={show} onHide={handleClose} centered>
        <Modal.Body>
          <div className="modaldelete_div">
            <Icon className="delete_icon" icon="gg:close-o"></Icon>
            <h3>Are You Sure ?</h3>
            <p>You will not be able to recover the deleted record!</p>
          </div>
          <Button onClick={handleClose} className="btn btn-primary-outline px-4 me-3">
            Cancel
          </Button>
          <Button className="btn btn-primary px-4 min_width110" onClick={handleDeleteFeedback}>
            Ok
          </Button>
        </Modal.Body>
      </Modal>

      <Modal show={sent} onHide={senttoggle} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            <h2 className="modalhead">Send Message</h2>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit(handleSendMessage)}>
            <Form.Group className="mb-3 form-group">
              <Form.Label>Subject</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter subject"
                {...register("subject")}
              />
              {errors.subject && (
                <p className="text-danger">{errors.subject.message}</p>
              )}
            </Form.Group>
            <Form.Group className="mb-3 form-group">
              <Form.Label>Message</Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                placeholder="Enter message"
                {...register("content")}
              />
              {errors.content && (
                <p className="text-danger">{errors.content.message}</p>
              )}
            </Form.Group>
            <Button onClick={senttoggle} className="btn btn-secondary px-4 min_width110">
              Cancel
            </Button>
            <Button type="submit" className="btn btn-primary px-4 mx-2 min_width110">
              Send
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
}
